'use strict';

var React = require('react');

var SvgGaugeMajor = function SvgGaugeMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 11.5a5.5 5.5 0 0 1 7.434-5.15l.456-.981a1.5 1.5 0 0 1 .234-.36 7 7 0 0 0-8.766 9.852.75.75 0 0 0 1.315-.722 5.472 5.472 0 0 1-.673-2.639Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.084 6.689-.695 1.496a5.475 5.475 0 0 1 1.111 3.315c0 .958-.244 1.857-.673 2.64a.75.75 0 1 0 1.315.72 6.972 6.972 0 0 0 .858-3.36 6.976 6.976 0 0 0-1.916-4.811Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 16a2 2 0 0 0 1.485-3.34l2.945-6.344a.75.75 0 1 0-1.36-.632l-2.935 6.32a2 2 0 1 0-.135 3.995Zm0-1.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z"
  }));
};
SvgGaugeMajor.displayName = "GaugeMajor";

exports.SvgGaugeMajor = SvgGaugeMajor;
